<template>
    <section class="op-list-container">
        <Table
            small
            tableClass="op-details-list"
            :responsive="true"
            :fields="fields"
            :items="items"
            :isBusy="busy"
            :sortBy="sortBy"
            :sortDesc="sortDesc"
            busyText="Lädt Buchungen..."
            emptyText="Keine Buchungen gefunden"
        >
            <template v-slot:head(id)>Buchungs-ID<br />Datum </template>

            <template v-slot:head(konto)>
                Verwendungszweck
            </template>

            <template v-slot:id="{ row: row }">
                <span class="text-secondary">{{ row.item.id }}</span>
                <br />
                {{ $moment(row.item.datum).format("DD.MM.YYYY") }}
            </template>

            <template v-slot:konto="{ row: row }">
                <span>{{ row.item.verwendungszweck }}</span>
            </template>

            <template v-slot:einnahmen="{ row: row }">
                <template v-if="row.item.betrag && row.item.betrag >= 0">
                    <template v-if="row.item.storno == 1">
                        <span class="text-secondary">{{
                                currency(row.item.betrag)
                            }}</span>
                    </template>
                    <template v-else>
                        <span class="text-success">{{
                                currency(row.item.betrag)
                            }}</span>
                    </template>
                </template>
            </template>

            <template v-slot:actions="{ row: row }">
                <b-button
                    v-if="checkRight('write')"
                    :size="size"

                    class="mv-table-action-btn mr-1"
                    :to="{ path: '/fibu/buchung/' + row.id }"
                >Buchung einsehen</b-button>
            </template>
        </Table>
    </section>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import { ApiFactory } from "@/api/ApiFactory.js";
import Table from "@/components/Table/Table";

import "./FiBuOPDetailList.scss";

const FiBuBuchungApi = ApiFactory.get("fibuBuchung");
const FiBuOffenePostenApi = ApiFactory.get("fibuOffenePosten");

export default {
    name: "FibuBuchungList",
    mixins: [CommonView, Size, Currency],
    components: {
        Table
    },
    props: ["filter", "finanzkonto", "buchungskonto", "mitglieder", "opId", "opItem"],
    data() {
        return {
            fields: [
                {
                    key: "id",
                    label: "Buchungs-ID",
                },
                {
                    key: "konto",
                    label: "Konto",
                },
                {
                    key: "einnahmen",
                    label: "verbuchter Betrag",
                }
            ],
            api: FiBuBuchungApi,
            opApi: FiBuOffenePostenApi,
            prefetch: false,
            lSortBy: null,
            sortDesc: false
        };
    },
    created() {
        const pages = this.$store.getters.getPages;
        if (pages.fibu_buchung) {
            this.pagination = pages.fibu_buchung.pagination;
        }

        if(this.opId) {
            this.fetchRelatedBuchungen(this.opId)
        }
    },
    computed: {
        sortBy() {
            return this.lSortBy
                ? this.lSortBy
                : this.filter
                    ? this.filter.orderby
                    : null;
        }
    },
    methods: {
        async fetchRelatedBuchungen(opId, busyState = true) {
            this.busy = busyState;
            const response = await this.opApi.getRelated(opId);

            if (response.ok) {
                var items = response.json.collection;
                if (items) {
                    items = items.map(item => {
                        if(item.verwendungszweck === "Dummybuchung für Mitgliedsbeiträge-Migration") {
                            item.verwendungszweck = `Mitgliedsbeitragzahlung ${this.opItem.mitgliedsbeitrag}`;
                            item.datum = this.opItem.datum;
                        }
                       return item;
                    });
                    this.items = items;
                    this.registerRights(response);
                } else {
                    this.items = [];
                }
            }
            this.busy = false;
        }
    }
};
</script>
